import { IActionFn } from '@/store/types';
import { IDetailResData, IListResData, IModuleState } from './types';
import { $tool } from '@/axios';
import { qs } from '@/utils/helper';

// 查询所有色表列表
export const queryColorTable: IActionFn<IModuleState> = async ({ commit }) => {
  try {
    commit('setColorTable', { data: [], loading: true });
    const res: IListResData = await $tool('color').post('color-table');
    commit('setColorTable', { data: res.table, loading: false });
  } catch (e) {
    commit('setColorTable', { data: [], loading: false });
  }
};

// 定位颜色并显示搭配关系
export const queryColorIndex: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setColorIndex', { data: null, loading: true });
    const config = { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } };
    const res: IDetailResData = await $tool('color').post('color-index', qs(payload), config);
    commit('setColorIndex', { data: res.color_index, loading: false });
  } catch (e) {
    commit('setColorIndex', { data: null, loading: false });
  }
};
